module.exports = __webpack_public_path__ + "static/media/dhcp_server.3d3b47fe.png";